import './bootstrap';

import { createApp } from 'vue'

import cookies from "./cookies.js";
import translations from "./translations.js";
import router from './router.js'

import Index from './components/Index.vue'
import Lang from "./components/Lang.vue";

const app = createApp({})

// Simple IntersectionObserver-based lazy-load directive
app.directive('lazy', {
    mounted(el, binding) {
        const setSrc = () => {
            if (binding?.value) {
                el.setAttribute('src', binding.value)
            }
        }

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setSrc()
                        obs.unobserve(entry.target)
                    }
                })
            }, {
                rootMargin: '200px 0px',
                threshold: 0.01,
            })
            observer.observe(el)
        } else {
            // Fallback: set immediately
            setSrc()
        }
    }
})

app
    .component('Index', Index)
    .component('Lang', Lang)
    .mixin(cookies)
    .mixin(translations)
    .use(router)

app.mount('root')
